import React, { useEffect, useState } from 'react';
import { Zap, Calendar } from 'lucide-react';

const slots = [
  { day: 'Heute',       time: '16:30', subject: 'Mathematik'  },
  { day: 'Heute',       time: '18:00', subject: 'Englisch'    },
  { day: 'Morgen',      time: '10:00', subject: 'Physik'      },
  { day: 'Morgen',      time: '15:30', subject: 'Deutsch'     },
  { day: 'Diese Woche', time: 'Mi 14:00', subject: 'Chemie'   },
];

export default function LiveAvailability({ className = '' }) {
  const [i, setI] = useState(0);
  const [fade, setFade] = useState(true);

  useEffect(() => {
    const id = setInterval(() => {
      setFade(false);
      setTimeout(() => {
        setI((prev) => (prev + 1) % slots.length);
        setFade(true);
      }, 260);
    }, 3400);
    return () => clearInterval(id);
  }, []);

  const s = slots[i];

  return (
    <div className={`inline-flex items-stretch bg-white rounded-2xl shadow-lg border border-slate-100 overflow-hidden ${className}`}>
      <div className="flex items-center gap-2 px-3" style={{ background: '#f0fdf4' }}>
        <span className="relative flex h-2.5 w-2.5">
          <span className="absolute inline-flex h-full w-full rounded-full opacity-70 animate-ping" style={{ background: '#16a34a' }} />
          <span className="relative inline-flex h-2.5 w-2.5 rounded-full" style={{ background: '#16a34a' }} />
        </span>
        <span className="text-[10px] font-bold uppercase tracking-wider" style={{ color: '#166534' }}>Live</span>
      </div>
      <div className="px-4 py-2.5">
        <div className="text-[10px] uppercase tracking-wider font-semibold text-slate-500 flex items-center gap-1">
          <Zap className="h-3 w-3" /> Nächster freier Termin
        </div>
        <div
          className="text-sm font-bold mt-0.5"
          style={{
            color: '#1a3a5c',
            opacity: fade ? 1 : 0,
            transform: fade ? 'translateY(0)' : 'translateY(4px)',
            transition: 'opacity 260ms ease, transform 260ms ease',
          }}
        >
          <Calendar className="h-3.5 w-3.5 inline mr-1" style={{ color: '#3d94b8' }} />
          {s.day} • {s.time} • <span style={{ color: '#3d94b8' }}>{s.subject}</span>
        </div>
      </div>
    </div>
  );
}
